var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "Personal Information Privacy Policy",
        "append-to-body": true,
        width: "783px",
        top: "100px",
        visible: _vm.isVisible,
        "close-on-click-modal": false,
        "close-on-press-escape": false
      },
      on: {
        "update:visible": function($event) {
          _vm.isVisible = $event
        }
      }
    },
    [
      _c(
        "div",
        {
          staticClass: "content",
          staticStyle: { "font-size": "12px", "line-height": "20px" }
        },
        [
          _c("p", [
            _vm._v(
              "This privacy policy (the “Privacy Policy”) applies to the relevant services (“Services”) provided by BASF (China) Co., Ltd. (hereinafter referred to as “BASF” or “us” or “we” or “our”) with the registered address at 300 Jiang Xin Sha Road, Pudong New District, Shanghai, via websites, mobile applications and other online portals (collectively referred to as the “Portal”) that link to BASF D’litE3-X (hereinafter referred to as “D’litE3-X”), which are developed and maintained by BASF Digital Solution GmbH. This Privacy Policy describes how BASF collects, uses, stores and shares personal information (hereinafter referred to as “Personal Information”) gathered via the Portals. We refer to the visitors of the Portals as users (“Users” or “you”). "
            )
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "BASF is fully aware of the importance of your Personal Information to you, and will do its utmost to protect the security and reliability of your Personal Information. We are committed to maintaining your trust in us, and abide by the following principles in our efforts to protect your Personal Information: commensurability of powers and responsibilities, clear purpose, consent, minimum necessary, security assurance, engagement of Subjects, openness and transparency,etc. In the meanwhile, BASF undertakes to take appropriate security protection measures to protect your Personal Information according to the established industry-specific security standards. "
            )
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "Please read carefully and understand this Personal Information Privacy Policy before using our Services. "
            )
          ]),
          _vm._v(" "),
          _c("p", [
            _c("strong", { staticStyle: { "font-size": "16px" } }, [
              _vm._v(
                "A. Rules on collection and use of Personal Information for Business Function"
              )
            ]),
            _c("strong")
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "In the following, we would like to inform you about how we handle personal information when you use this Service. Unless otherwise stated in the following sections, the legal basis for handling your personal information results from the necessity of data handling in order to provide the Service and the functionalities requested by you and for invoicing purposes. We also process data from the Service for other business purposes of the BASF Group, such as for the further development, production, and/or marketing of our products and services (including statistical purposes and for the continual improvement of our offers; in these cases, processing is carried out exclusively on an anonymous basis so that Personal Information cannot be traced back to you). "
            )
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "If you use our Service, your browser transfers certain data to our webserver for technical purposes in order to provide you with the information you have called up. In order to enable the use of the Service, the following data are collected, stored in the short-term, and used. In order to safeguard our legitimate interests, we also store such data for a limited time so that we may derive Personal Information in the event of unauthorized access or attempted access to the local server. "
            )
          ]),
          _vm._v(" "),
          _c("p", [
            _c("strong", { staticStyle: { "font-size": "14px" } }, [
              _vm._v("1. The Personal Information we collect and process")
            ]),
            _c("strong")
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "In order to use full functionalities of our Service, you may first register with a user account. You can set your\n      personal login details at a later login. When you register and login later, we collect and process the following\n      Personal Information about you: "
            )
          ]),
          _vm._v(" "),
          _c("ul", { staticStyle: { "list-style": "disc inside" } }, [
            _c("li", [_vm._v("Family name and given name ")]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "Contact details (including email address and telephone/mobile phone number for queries),  "
              )
            ]),
            _vm._v(" "),
            _c("li", [_vm._v("Username and password ")]),
            _vm._v(" "),
            _c("li", [
              _vm._v("Log data about your logins, including time stamp ")
            ])
          ]),
          _vm._v(" "),
          _c("p"),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "When you are using D’litE3-X App, our App will apply to you for the following Personal Information-related\n      system authorities: using camera, using photo album.  You can elect whether to grant such system authorities to our\n      App. If you do not grant such authorities, we will become unable to provide the relevant functions of our App to\n      you, while you are still able to use other functions of our App. "
            )
          ]),
          _vm._v(" "),
          _c("p"),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "When you use D’litE3-X services, we will collect the following information to provide you with\n      D’litE3-X services, maintain normal running of our services, improve and optimize our service experience and\n      safeguard your account security: Device information including device model, operating system, unique device\n      identifier, IMEI; device location information such as login IP address, MAC address; D’litE3-X version number;\n      and log information including manner, type and status of the network accessed, network quality data, operation log\n      and service log information. All the information collected will only be used for providing D’litE3-X services,\n      and not being disclosed to any unauthorized third-party. "
            )
          ]),
          _vm._v(" "),
          _c("p"),
          _vm._v(" "),
          _c("p", { attrs: { align: "justify" } }, [
            _c("strong", { staticStyle: { "font-size": "14px" } }, [
              _vm._v("2. Purpose for processing Personal Information")
            ]),
            _c("strong")
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "We process your Personal Information in order to enable your access to our Service or improve and optimize our\n      service experience and safeguard your account security. "
            )
          ]),
          _vm._v(" "),
          _c("p"),
          _vm._v(" "),
          _c("p", [
            _c("strong", { staticStyle: { "font-size": "14px" } }, [
              _vm._v(
                "3. Storing, sharing, and delegated processing of Personal Information"
              )
            ]),
            _c("strong")
          ]),
          _vm._v(" "),
          _c("p", [_vm._v("(1) Storing ")]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "We will store within China the Personal Information collected and produced from Users within China as provided for\n      in the laws and regulations. "
            )
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "In general, we will retain your Personal Information only for so long as is necessary to realize the purpose. For\n      example, if you want to use D’litE3-X services, we will store your mobile phone number data in order to enable\n      your access to our Service. The data will be automatically deleted upon deactivation of your user account. "
            )
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "When you send out comments, we will store the corresponding information in order to enable your use of comment\n      feature. We will delete the corresponding information when you delete your comments. "
            )
          ]),
          _vm._v(" "),
          _c("p", [_vm._v("(2) Sharing ")]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "We will not share your Personal Information with any company, organization or individual other than BASF and\n      Affiliates of BASF unless we have obtained your explicit consent. “Affiliate” shall mean, with respect\n      to BASF, any entity which, directly or indirectly, controls, is controlled by or is under the common control with\n      the Party. An entity shall be deemed to control another person if the controlling person possesses, directly or\n      indirectly, ownership of at least fifty percent (50%) of the equity shares of such an entity or has the power to\n      direct the management of such an entity. "
            )
          ]),
          _vm._v(" "),
          _c("p", [_vm._v("(3) Delegated processing ")]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "Certain modules or sub-functions in this business function will be provided by external suppliers. For example, we\n      will engage service providers to assist us in providing customer support. "
            )
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "We will sign strict confidentiality agreements with companies, organizations and individuals we have engaged to\n      process Personal Information, and require them to process Personal Information according to our requirements, this\n      Personal Information Protection Policy and any other related confidentiality and security measures. "
            )
          ]),
          _vm._v(" "),
          _c("p"),
          _vm._v(" "),
          _c("p", [
            _c("strong", { staticStyle: { "font-size": "14px" } }, [
              _vm._v("4. Use of cookies")
            ]),
            _c("strong")
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "We will inform you about using cookies in our cookie banner when you visit our website. You accept the use of\n      cookies by further using our website. A Cookie is a neutral technology that enables a website server to store data\n      on your device or to read data from your device. The Cookie assigned to you is unique and the content of it is\n      usually encrypted. Cookies notify us when you sign into our services so that we can authenticate your identity to\n      ensure the security of your account. Cookies help us to protect the security of our data and services, and to detect\n      cheating, hacker and fraudulent activities against our products or services. "
            )
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "We will not use cookies out of the scope of this Personal Information Privacy Policy. You may adjust your\n      preferences and submit your choice to either enable or disable cookies. You may use your browser settings to decide\n      which cookies to accept and to decline. You can erase all the cookies by clearing your cache. But please be aware\n      that you may not be able to enjoy the best service experience, some services also may not work properly if you\n      decline cookies. "
            )
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "For the details about use of cookies, you may refer to Cookie banner on D’litE3-X website. "
            )
          ]),
          _vm._v(" "),
          _c("p"),
          _vm._v(" "),
          _c("p", [
            _c("strong", { staticStyle: { "font-size": "14px" } }, [
              _vm._v("5. How do we protect your Personal Information")
            ]),
            _c("strong")
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "We will safeguard the security of information with various security protection measures within the reasonable\n      security level, including encryption techniques, anonymization and special management systems, processes and\n      organizations. We endeavor to safeguard the information security of the user to prevent the information from loss,\n      improper use, unauthorized access or disclosure. "
            )
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "D’litE3-X uses encryption technologies such as Secure Sockets Layer (SSL) via HTTPS ciphertext to secure the\n      security of data transmission. The Personal Information of Users will be fully protected by the aforesaid data\n      server from leaking to any unauthorized third party. We will strictly limit the personnel who can access your\n      Personal Information and check their fulfillment of the confidentiality obligations. "
            )
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "In case of halt of our products or services, we will notify you of the same by the means of push notification or\n      announcement, delete or anonymize your Personal Information within the reasonable period. "
            )
          ]),
          _vm._v(" "),
          _c("p"),
          _vm._v(" "),
          _c("p", [
            _c("strong", { staticStyle: { "font-size": "14px" } }, [
              _vm._v(
                "6. Integration of Software Development\n        Kit (SDK)"
              )
            ])
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "D’litE3-X integrates bellow software development Kits (SDKs) for realize some functions and features: "
            )
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "- In order to inform you our new products or new services, com.umeng is integrated  for push notification or\n      announcement. "
            )
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "- In order to realize features in the Video module, Kaltura Video Service "
            ),
            _c(
              "a",
              {
                attrs: {
                  href: "https://video.dlite3.basf.com",
                  target: "_blank"
                }
              },
              [_vm._v("https://video.dlite3.basf.com")]
            ),
            _vm._v(" is\n      integrated. ")
          ]),
          _vm._v(" "),
          _c("p"),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "This privacy policy doesn’t apply to the third-party products or services. We strongly recommend you read\n      through the privacy policy from them.  This privacy policy doesn’t apply to any other websites linked to our\n      Portals. "
            )
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "Bellow are privacy policies stated by above mentioned software: "
            )
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v("-  com.umeng privacy policy："),
            _c(
              "a",
              {
                attrs: {
                  href: "https://www.umeng.com/page/policy",
                  target: "_blank"
                }
              },
              [_vm._v("https://www.umeng.com/page/policy")]
            )
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v("- video.dlite3.basf.com Kaltura privacy policy："),
            _c(
              "a",
              {
                attrs: {
                  href:
                    "https://corp.kaltura.com/legal/privacy/privacy-policy/",
                  target: "_blank"
                }
              },
              [_vm._v("https://corp.kaltura.com/legal/privacy/privacy-policy/")]
            )
          ]),
          _vm._v(" "),
          _c("p"),
          _vm._v(" "),
          _c("p", [
            _c("strong", { staticStyle: { "font-size": "16px" } }, [
              _vm._v("B. About your rights")
            ]),
            _c("strong")
          ]),
          _vm._v(" "),
          _c("p", [_c("strong")]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "You may exercise the following rights based on the applicable personal information protection laws and regulations:\n    "
            )
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "1. The right of access to Your Personal Information that have been saved. "
            )
          ]),
          _vm._v(" "),
          _c("p", [_vm._v("1)  enter D’litE3-X，click “User Center”; ")]),
          _vm._v(" "),
          _c("p", [_vm._v("2)   click “My Profile”. ")]),
          _vm._v(" "),
          _c("p", [
            _vm._v("2. The right to rectify your Personal Information. ")
          ]),
          _vm._v(" "),
          _c("p", [_vm._v("1)   enter D’litE3-X，click “User Center”; ")]),
          _vm._v(" "),
          _c("p", [_vm._v("2)   click “My Profile”; ")]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "3)   change the name, phone no., log-on password and email address etc； "
            )
          ]),
          _vm._v(" "),
          _c("p", [_vm._v("4)   confirm after editing. ")]),
          _vm._v(" "),
          _c("p", [
            _vm._v("3. The right to delete your Personal Information ")
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "You can make a request for deletion of your Personal Information where: "
            )
          ]),
          _vm._v(" "),
          _c("ul", { staticStyle: { "list-style": "disc inside" } }, [
            _c("li", [
              _vm._v(
                "Our processing of your Personal Information violates any laws or regulations; "
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "We have collected or used your Personal Information without your consent; "
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "Our processing of your Personal Information violates the agreement with you; "
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "You no longer use our products or services, or you have cancelled your account; "
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v("We no longer provide products or services for you. ")
            ])
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "If we decide to respond to your request for deletion, we will also notify the entities that have obtained your\n      Personal Information from us and require them to delete such information in a promptly manner, except as otherwise\n      provided by laws and regulations, or unless these entities have obtained consent from you separately. "
            )
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "Where your Personal Information has been deleted from our service system, we may not delete the corresponding\n      information from the backup system immediately but will instead delete such information when the backup system is\n      updated. "
            )
          ]),
          _vm._v(" "),
          _c("p", [_vm._v("4. The right to withdraw consent ")]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "You may withdraw the consent you gave to the collection, storage, processing, use and transfer of your Personal\n      Information at any time. "
            )
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "If you withdraw your consent, we will cease processing the corresponding Personal Information. However, your\n      decision to withdraw your consent will not affect our previous Personal Information processing activities carried\n      out under your authorization. "
            )
          ]),
          _vm._v(" "),
          _c("p", [_vm._v("5. The right to de-registration ")]),
          _vm._v(" "),
          _c("p", [_vm._v("1)   enter D’litE3-X，click “User Center”; ")]),
          _vm._v(" "),
          _c("p", [_vm._v("2)   click “My Profile”; ")]),
          _vm._v(" "),
          _c("p", [_vm._v("3)   click “Security Setting”； ")]),
          _vm._v(" "),
          _c("p", [_vm._v("4)   click “Account Deregistration”; ")]),
          _vm._v(" "),
          _c("p", [_vm._v("5)   click “Apply for Deregistration” button. ")]),
          _vm._v(" "),
          _c("p", [
            _vm._v("6. To obtain copies of your Personal Information ")
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "You can request a copy of your personal information via email "
            ),
            _c("a", { attrs: { href: "mailto:CS.DlitE3-X@basf.com" } }, [
              _c("u", [_vm._v("CS.DlitE3-X@basf.com")])
            ]),
            _vm._v(
              ". We may ask you to verify your identity before\n      processing your requests. Where your identity confirmed and technically feasible, we will provide you a copy of your\n      Personal Information via email within fifteen (15) days. "
            )
          ]),
          _vm._v(" "),
          _c("p", [_vm._v("7. The right to request our response ")]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "To ensure security, you may need to submit a written request or otherwise prove your identity. We may ask you to\n      verify your identity before processing your requests. "
            )
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "In principle, we will respond to your requests within seven (7) days upon verification of your identity. If you are\n      dissatisfied with our response, you can also lodge a complaint via email "
            ),
            _c("a", { attrs: { href: "mailto:CS.DlitE3-X@basf.com" } }, [
              _c("u", [_vm._v("CS.DlitE3-X@basf.com")])
            ]),
            _vm._v(
              ". We will review the issue involved as soon as\n      possible and give you the reply within fifteen (15) days. "
            )
          ]),
          _vm._v(" "),
          _c("p"),
          _vm._v(" "),
          _c("p", [
            _c("strong", { staticStyle: { "font-size": "16px" } }, [
              _vm._v("C. Contact details")
            ]),
            _c("strong")
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "If you have any concerns regarding data protection, please contact our Group Data Protection Officer at the\n      following address: Group Data Protection Officer Ms Alexandra Haug EU Data Protection Officer 67056 Ludwigshafen,\n      Germany +49 (0) 621 60-0 "
            ),
            _c("br"),
            _vm._v("\n      Email: "),
            _c("a", { attrs: { href: "mailto:data-protection.eu@basf.com" } }, [
              _c("u", [_vm._v("data-protection.eu@basf.com")])
            ]),
            _c("u")
          ]),
          _vm._v(" "),
          _c("p"),
          _vm._v(" "),
          _c("p", [
            _c("strong", { staticStyle: { "font-size": "16px" } }, [
              _vm._v("D. Updating the Personal Information Privacy Policy")
            ]),
            _c("strong")
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "We reserve the right to update this Personal Information Privacy Policy from time to time. Any updates to this Data\n      Privacy Policy shall be published on our Portals. Amendments apply as soon as they are published on our Portals. We\n      therefore recommend that you visit our Portals regularly so that, if necessary, you can keep yourself informed of\n      any updates. "
            )
          ]),
          _vm._v(" "),
          _c("p", [_vm._v("Last updated: [2021-12-07] ")])
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          staticStyle: { "text-align": "center" },
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary" },
              on: {
                click: function($event) {
                  _vm.isVisible = false
                }
              }
            },
            [_vm._v("Confirm")]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c1cb3d64", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c1cb3d64","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/agreement/Pren.vue
// module id = null
// module chunks = 